import { Link, useNavigate } from "react-router-dom";
import FloatingLabelInput from "../../Common/FloatingLabel";
import { useEffect, useState } from "react";
import { AddChild, EditChild, RemoveChild } from "../../api/api";
import toast, { Toaster } from "react-hot-toast";
import Spinner from "../../Common/Spinner";
import { GetChild, GetSingleChild } from "../../api/get";
import Header from "../../Common/Header";
import Loader from "../../loader";
import { useFormik } from "formik";
import * as Yup from "yup"; // Import Yup for validation
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import { FaInfoCircle } from "react-icons/fa";
import { Modal } from "react-responsive-modal";
import { FaAngleLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa";
import { handleApiError } from "../../Common/Helper";
const YourChild = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [getChild, setGetChild] = useState([]); // Initialize getChild as an empty array
  const [save, setSave] = useState(false);
  const [contentLoder, setContentLoader] = useState(true);
  const [isFocused, setIsFocused] = useState(false);
  const [isFocusedEdit, setIsFocusedEdit] = useState(false);

  const autoCorrectedDatePipe = createAutoCorrectedDatePipe("dd/mm/yyyy");
  const [refresh, setRefresh] = useState(false); // Track changes
  const [childOpensec, setChildOpensec] = useState();
  useEffect(() => {
    GetChild()
      .then((res) => {
        console.log(res);
        if (res.success && res.status_code === "200") {
          setGetChild(res.data);
          setContentLoader(false);
        } else {
          handleApiError(res, navigate); // Use helper function
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [refresh]);
  console.log("getChild =>", getChild);
  // Helper function to format date in dd/mm/yyyy format
  const formatDate = (dateString) => {
    const date = new Date(dateString); // Create a Date object from the string
    const day = String(date.getDate()).padStart(2, "0"); // Get the day with leading zero if needed
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Get the month (0-based, so add 1)
    const year = date.getFullYear(); // Get the year
    return `${day}/${month}/${year}`; // Return the formatted date
  };
  // Handle API errors uniformly
  // const handleApiError = (response) => {
  //   if (response.status_code === "501") {
  //     toast.error(response.data.error);
  //   } else if (response.status_code === "422") {
  //     const errorMessages = Object.values(response.data.error)
  //       .flat()
  //       .join(", ");
  //     toast.error(errorMessages);
  //   }
  // };
  // Call GetSingleChild API when Edit button is clicked
  const fetchSingleChild = (id, index) => {
    GetSingleChild(id)
      .then((detail) => {
        if (detail.success && detail.status_code === "200") {
          if (detail && detail.data.beneficiary_first_name) {
            // Format the beneficiary_dob to dd/mm/yyyy
            const formattedDob = formatDate(detail.data.beneficiary_dob);
            EditChildFormik.setValues({
              beneficiary_first_name: detail.data.beneficiary_first_name,
              beneficiary_last_name: detail.data.beneficiary_last_name,
              beneficiary_dob: formattedDob,
              child_id: id,
            });
            setChildOpensec(index); // Open the modal by setting the child index
          }
        } else {
          handleApiError(detail, navigate);
        }
      })
      .catch((error) => {
        toast.error("Failed to fetch child details");
        console.error(error);
      });
  };

  const RemoveChildFunction = (child_id) => {
    RemoveChild(child_id)
      .then((res) => {
        if (res.success && res.status_code === "200") {
          setRefresh(!refresh); // Trigger refresh after deletion
          setChildOpensec(null);
          toast.success("Child removed successfully");
        } else {
          handleApiError(res, navigate);
        }
      })
      .catch(() => toast.error("Failed to remove child"));
  };

  // Yup validation schema
  const validationSchema = Yup.object().shape({
    beneficiary_first_name: Yup.string().required("Required field"),
    beneficiary_last_name: Yup.string().required("Required field"),
    beneficiary_dob: Yup.string()
      .nullable()
      .matches(
        /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
        "Date of birth must be in dd/mm/yyyy format"
      )
      .required("Required field")
      .test("is-past-date", "Date must be in the past", (value) => {
        if (!value) return true; // Skip if empty
        const [day, month, year] = value.split("/");
        const enteredDate = new Date(`${year}-${month}-${day}`);
        return enteredDate < new Date();
      })
      .test(
        "is-after-1900",
        "Please enter a date of birth after 1900",
        (value) => {
          if (!value) return true; // Skip if empty
          const [day, month, year] = value.split("/");
          return parseInt(year) > 1900;
        }
      ),
  });

  const formik = useFormik({
    initialValues: {
      beneficiary_first_name: "",
      beneficiary_last_name: "",
      beneficiary_dob: "",
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      // Convert beneficiary_dob to "yyyy-mm-dd" format
      if (values.beneficiary_dob) {
        const [day, month, year] = values.beneficiary_dob.split("/");
        values.beneficiary_dob = `${year}-${month}-${day}`;
      }

      console.log("Formatted Values =>", values);
      // setLoading(true);
      AddChild(values)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            toast.success("Child added successfully");
            resetForm(); // This will clear the form fields
            setRefresh((prev) => !prev);
          } else {
            handleApiError(res, navigate);
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.error("An error occurred");
          console.log(err);
        });
    },
  });

  const EditChildFormik = useFormik({
    initialValues: {
      child_id: "", // Make sure to include this field in the form
      beneficiary_first_name: "",
      beneficiary_last_name: "",
      child_id: "",
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      // Convert beneficiary_dob to "yyyy-mm-dd" format
      if (values.beneficiary_dob) {
        const [day, month, year] = values.beneficiary_dob.split("/");
        values.beneficiary_dob = `${year}-${month}-${day}`;
      }
      EditChild(values)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            toast.success("Child updated successfully");
            resetForm(); // This will clear the form fields
            setRefresh((prev) => !prev);
            setChildOpensec(null);
          } else {
            handleApiError(res, navigate);
          }
        })
        .catch((err) => {
          toast.error("An error occurred");
        });
    },
  });

  return (
    <>
      {contentLoder ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          <Toaster />
          <Header />
          <div className="container">
            <div className="grid grid-cols-2 max-lg:grid-cols-1">
              <div>
                <div>
                  <h4 className="text-black font-bold mt-[25px] text-[26px] sm:text-[30px] lg:text-[34px]">
                    Add your child
                  </h4>
                  <p className="text-slate-500 my-2">
                    It’s important to add all your children so that they are
                    identified in your will, even if you don’t plan to include
                    them in your estate.
                  </p>
                  <p className="text-slate-500 my-2">
                    If you’re expecting a child, don’t add them for now. You can
                    update your will once they’re born. Stepchildren don’t need
                    to be added here either: if you want to include them in your
                    estate you can do so later on.
                  </p>
                </div>

                <div>
                  <div>
                    <form onSubmit={formik.handleSubmit} name="frmchild">
                      <div className="grid grid-cols-2 gap-5 ">
                        <div className="mt-2 mb-4 ">
                          <FloatingLabelInput
                            label="First Name"
                            type="text"
                            id={`beneficiary_first_name`}
                            value={formik.values.beneficiary_first_name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.beneficiary_first_name &&
                              formik.errors.beneficiary_first_name
                            }
                          />
                        </div>
                        <div className="mt-2 mb-4 ">
                          <FloatingLabelInput
                            label="Last Name"
                            type="text"
                            id={`beneficiary_last_name`}
                            name="beneficiary_last_name"
                            value={formik.values.beneficiary_last_name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.beneficiary_last_name &&
                              formik.errors.beneficiary_last_name
                            }
                          />
                        </div>
                      </div>
                      <div className="w-full mt-5 pb-5  ">
                        <div className="relative w-full border-2 h-[60px] flex items-center">
                          <MaskedInput
                            mask={[
                              /\d/,
                              /\d/,
                              "/",
                              /\d/,
                              /\d/,
                              "/",
                              /\d/,
                              /\d/,
                              /\d/,
                              /\d/,
                            ]}
                            placeholder={
                              isFocused || formik.values.beneficiary_dob
                                ? "dd/mm/yyyy"
                                : ""
                            }
                            pipe={autoCorrectedDatePipe}
                            value={formik.values.beneficiary_dob}
                            onFocus={() => setIsFocused(true)}
                            onBlur={(e) => {
                              setIsFocused(false);
                              formik.handleBlur(e); // To ensure Formik registers field as "touched"
                            }}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "beneficiary_dob",
                                e.target.value
                              );
                            }}
                            className="block text-black w-full px-[20px] h-full appearance-none focus:outline-none focus:ring-0 peer border-red-500 focus:border-red-500"
                            name="beneficiary_dob"
                          />

                          <label
                            htmlFor="dob"
                            className="absolute left-5 top-[16px]  text-gray-500 transition-all duration-200 transform text-[10px] -translate-y-3.5 peer-placeholder-shown:text-[16px] peer-placeholder-shown:translate-y-0 peer-focus:text-[10px] peer-focus:-translate-y-3.5"
                          >
                            Date of birth
                          </label>
                        </div>
                        {formik.touched.beneficiary_dob &&
                        formik.errors.beneficiary_dob ? (
                          <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                            <FaInfoCircle />
                            <p className="text-white py-1 px-2 text-sm my-2">
                              {formik.errors.beneficiary_dob}
                            </p>
                          </div>
                        ) : null}
                      </div>

                      <div className="pb-5 border-b-2 border-dashed">
                        {loading === true ? (
                          <button className="border-2 w-full bg-primary flex justify-center rounded-[5px] border-[#240642] text-[#240642] px-4 py-2 hover:bg-primary hover:text-white transition-all ease-out font-bold">
                            <Spinner />
                          </button>
                        ) : (
                          <button
                            type="submit"
                            className="border-2 w-full rounded-[5px] border-[#240642] text-[#240642] px-4 py-2 hover:bg-primary hover:text-white transition-all ease-out font-bold"
                          >
                            Add another child
                          </button>
                        )}
                      </div>
                    </form>
                  </div>
                  <div>
                    {getChild?.length > 0 ? (
                      <div>
                        <h6 className="text-[24px] text-black font-bold mt-[36px]">
                          Your children
                        </h6>
                      </div>
                    ) : (
                      ""
                    )}
                    {getChild?.length > 0 ? (
                      getChild.map((children, index) => (
                        <div
                          key={children.id}
                          className="pt-5 flex items-center justify-between"
                        >
                          <div className="border-2 rounded-lg p-3 w-full flex justify-between items-center">
                            <div className="flex">
                              <div>
                                <img
                                  className=""
                                  src="/assets/images/document-header.png"
                                  alt="mascot-small"
                                  style={{
                                    height: "45px",
                                    width: "45px",
                                    borderRadius: "50%",
                                  }}
                                />
                              </div>
                              <div className="mx-4">
                                <p className="text-[12px] font-bold"></p>
                                <p className="text-[18px] font-bold">
                                  {children?.beneficiary_first_name || ""}{" "}
                                  {children?.beneficiary_last_name || ""}
                                </p>
                                <p className="text-[12px] ">Your child</p>
                              </div>
                            </div>
                            <button
                              className="border-2 hover:bg-primary hover:text-white transition-all ease-out rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold"
                              onClick={() =>
                                fetchSingleChild(children.id, index)
                              }
                            >
                              Edit
                            </button>
                            <Modal
                              open={childOpensec === index}
                              onClose={() => setChildOpensec(null)}
                              center
                              classNames={{
                                modal:
                                  "rounded-[5px] p-5 max-w-[90%] md:w-[50%] lg:w-[35%] ", // Adjust width for responsiveness
                              }}
                            >
                              <form
                                onSubmit={EditChildFormik.handleSubmit}
                                className="mx-5"
                              >
                                <div>
                                  <h2 className="font-bold text-[20px] md:text-[24px] ">
                                    Edit Child
                                  </h2>
                                  <input
                                    type="hidden"
                                    name="child_id"
                                    value={EditChildFormik.values.child_id}
                                  />
                                  <div className="flex flex-col md:flex-row items-center gap-5 mt-[30px]">
                                    <div className="w-full md:w-[50%]">
                                      <FloatingLabelInput
                                        label="First Name"
                                        type="text"
                                        id={`beneficiary_first_name`}
                                        name="beneficiary_first_name"
                                        value={
                                          EditChildFormik.values
                                            .beneficiary_first_name
                                        }
                                        onChange={EditChildFormik.handleChange}
                                        onBlur={EditChildFormik.handleBlur}
                                        error={
                                          EditChildFormik.touched
                                            .beneficiary_first_name &&
                                          EditChildFormik.errors
                                            .beneficiary_first_name
                                        }
                                      />
                                    </div>
                                    <div className="w-full md:w-[50%]">
                                      <FloatingLabelInput
                                        label="Last Name"
                                        type="text"
                                        id={`beneficiary_last_name`}
                                        name="beneficiary_last_name"
                                        value={
                                          EditChildFormik.values
                                            .beneficiary_last_name
                                        }
                                        onChange={EditChildFormik.handleChange}
                                        onBlur={EditChildFormik.handleBlur}
                                        error={
                                          EditChildFormik.touched
                                            .beneficiary_last_name &&
                                          EditChildFormik.errors
                                            .beneficiary_last_name
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="mt-5 pb-5">
                                  <div className="relative w-full border-2 h-[60px] flex items-center">
                                    <MaskedInput
                                      mask={[
                                        /\d/,
                                        /\d/,
                                        "/",
                                        /\d/,
                                        /\d/,
                                        "/",
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                      ]}
                                      placeholder={
                                        isFocusedEdit ||
                                        EditChildFormik.values.beneficiary_dob
                                          ? "dd/mm/yyyy"
                                          : ""
                                      }
                                      pipe={autoCorrectedDatePipe}
                                      value={
                                        EditChildFormik.values.beneficiary_dob
                                      }
                                      onFocus={() => setIsFocusedEdit(true)}
                                      onBlur={(e) => {
                                        setIsFocusedEdit(false);
                                        EditChildFormik.handleBlur(e); // To ensure Formik registers field as "touched"
                                      }}
                                      onChange={(e) => {
                                        EditChildFormik.setFieldValue(
                                          "beneficiary_dob",
                                          e.target.value
                                        );
                                      }}
                                      className="block text-black w-full px-[20px] h-full appearance-none focus:outline-none focus:ring-0 peer"
                                      name="beneficiary_dob"
                                    />
                                    <label
                                      htmlFor="dob"
                                      className="absolute left-5 top-[16px] text-gray-500 transition-all duration-200 transform text-[10px] -translate-y-3.5 peer-placeholder-shown:text-[16px] peer-placeholder-shown:translate-y-0 peer-focus:text-[10px] peer-focus:-translate-y-3.5"
                                    >
                                      Date of birth
                                    </label>
                                  </div>
                                  <div>
                                    {EditChildFormik.touched.beneficiary_dob &&
                                    EditChildFormik.errors.beneficiary_dob ? (
                                      <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                                        <FaInfoCircle />
                                        <p className="text-white py-1 px-2 text-sm my-2">
                                          {
                                            EditChildFormik.errors
                                              .beneficiary_dob
                                          }
                                        </p>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                                <div className="flex flex-col md:flex-row justify-between items-center gap-5 mb-5">
                                  <div className="w-full md:w-[50%]">
                                    <button
                                      type="submit"
                                      className="w-full bg-primary px-5 py-3 text-white font-muli font-semibold rounded-[5px] flex justify-center items-center gap-2"
                                    >
                                      Update Child
                                    </button>
                                  </div>
                                  <div className="w-full md:w-[50%]">
                                    <button
                                      type="button"
                                      onClick={() =>
                                        RemoveChildFunction(
                                          EditChildFormik.values.child_id
                                        )
                                      }
                                      className="w-full border-[1px] border-[#240642] hover:bg-primary hover:text-white border-solid text-black px-5 py-3 font-muli font-semibold rounded-[5px] flex justify-center items-center gap-2"
                                    >
                                      Remove Child
                                    </button>
                                  </div>
                                </div>
                              </form>
                            </Modal>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="py-5 w-[100%] ">
                        <p className="text-black font-bold">
                          No children found
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="border-b-2 my-5"></div>
                  <div className="flex justify-between my-3">
                    <Link to={"/make-will-online/about-yourself/partner"}>
                      <button className="flex items-center justify-center gap-1 font-semiold text-[20px] py-2 rounded-[10px] mt-5 text-slate-500">
                        <FaAngleLeft />
                        Back
                      </button>
                    </Link>
                    {save ? (
                      <button className="px-5 py-3 mt-3 text-white font-bold bg-primary rounded  ">
                        <Spinner />
                      </button>
                    ) : (
                      <button
                        onClick={(e) => {
                          setSave(false);
                          navigate("/make-will-online/about-yourself/pets");
                        }}
                        className="px-5 py-3 mt-3 text-white font-bold bg-primary rounded flex items-center gap-1 "
                      >
                        Next <FaChevronRight />
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className="max-lg:hidden bg-no-repeat">
                <div className="fixed top-0 w-[500px] right-[6%] bg-cloud">
                  <img src="/assets/images/4.png" alt="mascot" />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default YourChild;
